



























































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  mounted() {
    this.loadData22();
  }

  async loadData22() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("bill/taisamHistory", {
      bill_id: this.editId
    });

    this.spinLoading = false;

    if (res && res.Data) {
      this.formData = res.Data;
    }
  }
}
